
import { lazy } from "react";
export {default as Home} from './Home/Home'
export {default as Milestones} from './Milestone/Milestones'
export {default as About} from './About/About'
export {default as Vision} from './Vision/Vision'
export {default as Office} from './Office/Office'
export {default as Clubs} from './Clubs/Clubs'
export {default as Alumni} from './Alumni/Alumni'
export {default as Nss} from './Nss/Nss'
export {default as Ncc} from './Ncc/Ncc'
export {default as Teqip1} from './Teqip1/Teqip1'
export {default as Teqip2} from './Teqip2/Teqip2'
export {default as Teqip3} from './Teqip3/Teqip3'
export {default as ProgramsOffered} from './Programs_offered/Programs_offered'
export {default as Life} from './Life/Life'
export {default as T3Officials} from './T3_officials/T3_officials'
export {default as T3Acad} from './T3_acad/T3_acad'
export {default as T3Procure} from './T3_procure/T3_procure'
export {default as T3Twin} from './T3_twin/T3_twin'
export {default as Govern} from './Govern/Govern'
export {default as Aicte} from './Aicte/Aicte'
export {default as Organisation} from './Organisation/Organisation'
export {default as Under} from './Under/Under'
export {default as Thiran} from './Thiran/Thiran'
export {default as Sports} from './Sports/Sports'
export {default as Csedept} from './Csedept/Csedept'
export {default as Ecedept} from './Ecedept/Ecedept'
export {default as Ece_peo} from './Ecedept/Ece_peo'
export {default as Ece_faculties} from './Ecedept/Ece_faculties'
export {default as Ece_lab} from './Ecedept/Ece_lab'
export {default as Ece_research} from './Ecedept/Ece_research'
export {default as Ece_rankers} from './Ecedept/Ece_rankers'
export {default as Mech_rankers} from './Mechdept/Mech_rankers'
export {default as Ece_events} from './Ecedept/Ece_events'
export {default as Ece_projects} from './Ecedept/Ece_projects'
export {default as Ece_stud_activity} from './Ecedept/Ece_stud_activity'
export {default as Ece_antenna} from './Ecedept/Ece_antenna'
export {default as Annual_report} from './Annual_Report/Annual_report'
export {default as Academic} from './Academic/Academic'
export {default as Fees} from './Fees/Fees'
export {default as Cse_faculties} from './Csedept/Cse_faculties'
export {default as Civildept} from './Civildept/Civildept'
export {default as Mechdept} from './Mechdept/Mechdept'
export {default as Eeedept} from './Eeedept/Eeedept'
export {default as Cse_peo} from './Csedept/Cse_peo'
export {default as Cse_lab} from './Csedept/Cse_lab'
export {default as Cse_events} from './Csedept/Cse_events'
export {default as Cse_prog_org} from './Csedept/Cse_prog_org'
export {default as Cse_mou} from './Csedept/Cse_mou'
export {default as Codequest} from './Csedept/Codequest'
export {default as Cse_projecthon} from './Csedept/Cse_projecthon'
export {default as Civil_peo} from './Civildept/Civil_peo'
export {default as Civil_faculties} from './Civildept/Civil_faculties'
export {default as Civil_lab} from './Civildept/Civil_lab'
export {default as Civil_events} from './Civildept/Civil_events'
export {default as Civil_magazine} from './Civildept/Civil_magazine'
export {default as Civil_indus} from './Civildept/Civil_indus'
export {default as Mech_peo} from './Mechdept/Mech_peo'
export {default as Mech_faculties} from './Mechdept/Mech_faculties'
export {default as Mech_lab} from './Mechdept/Mech_lab'
export {default as Mech_events} from './Mechdept/Mech_events'
export {default as Mech_achievements} from './Mechdept/Mech_achievements'
export {default as Eee_peo} from './Eeedept/Eee_peo'
export {default as Eee_faculties} from './Eeedept/Eee_faculties'
export {default as Eee_lab} from './Eeedept/Eee_lab'
export {default as Eee_events} from './Eeedept/Eee_events'
export {default as Eee_modern} from './Eeedept/Eee_modern'
export {default as Ece_placement} from './Ecedept/Ece_placement'
export{default as Ece_alumni91} from './Ecedept/Ece_alumni91'
export{default as Ece_alumni92} from './Ecedept/Ece_alumni92'
export{default as Ece_alumni93} from './Ecedept/Ece_alumni93'
export{default as Ece_alumni_notable} from './Ecedept/Ece_alumni_notable'
export{default as Ece_alumni}from './Ecedept/Ece_alumni'
export {default as Ece_elect_test_coe} from './Ecedept/Ece_elect_test_coe'

export {default as Ece_skill_development} from './Ecedept/Ece_skill_development'
export {default as Ece_passed_out_students} from './Ecedept/Ece_passed_out_students'
export {default as Ece_funded_project} from './Ecedept/Ece_funded_project'
export {default as EDC} from './EDC/EDC'



export {default as Iqac} from './Iqac/Iqac'
export {default as Iqac_min} from './Iqac_min/Iqac_min'
export {default as Iqac_aqar} from './Iqac_aqar/Iqac_aqar'
export {default as Iqac_feed} from './Iqac_feed/Iqac_feed'
export {default as Iqac_blocks} from './Iqac_blocks/Iqac_blocks'
export {default as Iqac_distinctiveness} from './Iqac_distinctiveness/Iqac_distinctiveness'
export {default as Iqac_practices} from './Iqac_practices/Iqac_practices'
export {default as Iqac_std_statisfy} from './Iqac_std_statisfy/Iqac_std_statisfy'
export {default as Iqac_committee} from './Iqac_committee/Iqac_committee'

export {default as Sgpa}from './Sgpa/Sgpa'
export {default as Nba} from './Nba/Nba'
export {default as Nbadoc} from './Nba/Nbadoc'
export {default as Nba_sar} from './Nba/Nba_sar'
export {default as Nirf} from './Nirf/Nirf'
export {default as Iic} from './Iic/Iic'
export {default as Scholarship} from './Scholarship/Scholarship'
export {default as Civil_awards} from './Civildept/Civil_awards'
export {default as Ece_dept_lib} from './Ecedept/Ece_dept_lib'
export {default as Iste} from './Iste/Iste'
export {default as Uba} from './Uba/Uba'
export {default as Sih} from './Sih/Sih'
export {default as Committee} from './Committee/Committee'
export {default as Yrc} from './Yrc/Yrc'
export {default as Devpage} from './Devpage/Devpage'
export {default as Eee_research} from './Eeedept/Eee_research'
export {default as Eee_nextgen} from './Eeedept/Eee_nextgen'
export {default as Civil_library} from './Civildept/Civil_library'
export {default as Civil_placement} from './Civildept/Civil_placement'
export {default as Civil_internal} from './Civildept/Civil_internal'
export {default as Civil_research} from './Civildept/Civil_research'
export {default as Facilities} from './Facilities/Facilities'
export {default as Eee_lib} from './Eeedept/Eee_lib'
export {default as Eee_studcorner} from './Eeedept/Eee_studcorner'
export{default as Mech_lib} from './Mechdept/Mech_lib'
export{default as Mech_phd} from'./Mechdept/Mech_phd'
export{default as Mech_org} from'./Mechdept/Mech_org'
// export{default as Placement} from './Placement/placement'
export{default as Mech_coe} from './Mechdept/Mech_coe'
export{default as Coe} from './coe/Coe'
export{default as Coe_Adminstration}from'./coe/Coe_Adminstration'
export {default as Coe_Academic}from'./coe/Coe_Academic'
export {default as Coe_link}from'./coe/Coe_link'
export {default as Coe_Contact}from'./coe/Coe_Contact'
export {default as Coe_Application}from'./coe/Coe_Application'
export {default as Coe_Claim}from'./coe/Coe_Claim'
export {default as Coe_FeeStruct}from'./coe/Coe_FeeStruct'
export {default as Coe_syllabuss}from'./coe/Coe_syllabuss'

export{default as Naac_best_practices} from './Naac/Naac_best_practices'
export{default as Naac_best2324} from './Naac/Naac_best2324'
export {default as Coe_syllabus1}from'./coe/Coe_syllabus1'
export {default as Coe_Committiee}from'./coe/Coe_Committiee'
export{default as Placement} from './placement/placement'
export {default as Placement_faq} from './placement/Placement_Faq'
export {default as Placement_wk_training} from './placement/Placement_wk_training'
export {default as Placement_stats} from './placement/Placement_stats'
export {default as Placement_companies} from './placement/Placement_companies'

// export{default as Mech_coe} from'./Mechdept/Mech_coe'
export{default as Login} from './Login/Login'
export{default as Dashboard} from './Dashboard/Dashboard'
export{default as Dash_results} from './Dashboard/Dash_results'
export{default as Marksheet} from './Dashboard/Marksheet' //Ak
export{default as Logout} from './Logout/Logout'
export{default as Passreset} from './Passreset/Passreset'
export{default as Otp} from './Otp/Otp'
export{default as Newpass} from './Newpass/Newpass'
export{default as Admin_dashboard} from './Admin_dashboard/Admin_dashboard'
export{default as ForgetPassword} from './Admin_dashboard/ForgetPassword'
export {default as GetUserDetails} from './Admin_dashboard/GetUserDetails'
export {default as AddStudent} from './Admin_dashboard/AddStudent'
export {default as DeleteStudent} from './Admin_dashboard/DeleteStudent'
export {default as Studentresult} from './Admin_dashboard/Studentresult'
export {default as Dash_results_pt_ft} from './Dashboard/Dash_results_pt_ft'
export {default as Dash_results_ME} from './Dashboard/Dash_results_ME'
export{default as Research} from './Research/Research'

export{default as Physicsdept} from './Physicsdept/Physicsdept'
export {default as Physics_faculty} from './Physicsdept/Physics_faculty'
export {default as Physics_lab_facility} from './Physicsdept/Physics_lab_facility'
export {default as Physics_research} from './Physicsdept/Physics_research'
export {default as Physics_programme} from './Physicsdept/Physics_programme'
export {default as Physics_former_prof} from './Physicsdept/Physics_former_prof'

export{default as Chemistrydept} from './Chemistrydept/Chemistrydept'
export {default as Chemistry_faculty} from './Chemistrydept/Chemistry_faculty'
export {default as Chemistry_lab_facility} from './Chemistrydept/Chemistry_lab_facility'
export {default as Chemistry_research} from './Chemistrydept/Chemistry_research'
export {default as Chemistry_programme} from './Chemistrydept/Chemistry_programme'

export{default as Mathsdept} from './Mathsdept/Mathsdept'
export {default as Maths_faculty} from './Mathsdept/Maths_faculty'
export {default as Maths_lab_facility} from './Mathsdept/Maths_lab_facility'
export {default as Maths_research} from './Mathsdept/Maths_research'
export {default as Maths_programme} from './Mathsdept/Maths_programme'

export{default as Englishdept} from './Englishdept/Englishdept'
export {default as English_faculty} from './Englishdept/English_faculty'
export {default as English_lab_facility} from './Englishdept/English_lab_facility'
export {default as English_research} from './Englishdept/English_research'
export {default as English_programme} from './Englishdept/English_programme'

export{default as Naac} from './Naac/Naac'
export{default as Rti} from './Rti/Rti'
export{default as Ignatz} from './Sports/Ignatz'
export{default as Maverickz} from './Sports/Maverickz'
export{default as Phoenix} from './Sports/Phoenix'
export{default as Akkadians} from './Sports/Akkadians'
export{default as Gladiatorz} from './Sports/Gladiatorz'
export{default as Audit_stmt} from './Audit_stmt/Audit_stmt'
export{default as Verification} from './Verification/Verification'
export{default as Iqac_strategic} from './Iqac_strategic/Iqac_strategic'
export{default as Autonomous} from './Autonomous/Autonomous'
export {default as Build}from'./Clubs/Build'


export{default as Feedback} from './Feedback/Feedback'
export{default as Faculty_fb} from './Feedback/Faculty_fb'
export{default as Alumini_fb} from './Feedback/Alumini_fb'
export{default as Collaborator_fb} from './Feedback/Collaborator_fb'
export{default as Student_fb} from './Feedback/Student_fb'
export{default as Std_teaching_fb} from './Feedback/Std_teaching_fb'
export{default as Std_mini_project_fb} from './Feedback/Std_mini_project_fb'
export{default as Employer_fb} from './Feedback/Employer_fb'
export{default as Technical_fb} from './Feedback/Technical_fb'
export{default as Practical_fb} from './Feedback/Practical_fb'
export{default as Sports_achivement} from './Sports/Sports_achievement'
export{default as BoG} from './BoG/BoG'

// export{default as Parents_fb}from './Feedback/Parents_fb'
// export{default as Consultancy_fb} from './Feedback/Consultancy_fb'
export{default as Supplier_fb} from './Feedback/Supplier_fb'
export{default as Parents_fb}from './Feedback/Parents_fb'
export{default as Consultancy_fb} from './Feedback/Consultancy_fb'
export{default as FeedbackPdf} from './FeedbackPdf/FeedbackPdf'
export{default as Graduatesinfo} from './Graduates/Graduatesinfo'
export{default as Coe_mou} from './Coe_mou/Coe_mou'
export{default as Std_statisf} from './Feedback/Std_statisf'
export{default as Std_fac} from './Feedback/Std_fac'
export{default as Sdgclub} from './Sdgclub/Sdgclub'
export {default as Library} from './Library/Library'
export {default as Rules_and_regulations} from './Library/Rules_and_regulations'
export {default as E_resources_and_journals} from './Library/E_resouces_and_journals'
export {default as Privileges} from './Library/Privileges'
export {default as Live_projects} from './Csedept/Live_projects'
export {default as Other_facility} from './Library/Other_facility'
export {default as AI_bots} from './Library/AI_bots'
export {default as Notetaking} from './Library/AItools/Notetaking'
export {default as Essaywriting} from './Library/AItools/Essaywriting'
export {default as Examprep} from './Library/AItools/Examprep'
export {default as Careerplanning} from './Library/AItools/Careerplanning'
export {default as Presentations} from './Library/AItools/Presentations'
export {default as Productivity} from './Library/AItools/Productivity'
export {default as Studyassistants} from './Library/AItools/Studyassistans'
export const Programs_organized = lazy(() => import("./Programmes/Programs_organized"));
export {default as NotFound} from './NotFound/NotFound'
export {default as Incubation} from './Incubation/Incubation'
export {default as Freshers_asso} from './Freshers_asso/Freshers_asso'
export {default as Incubation_facilities} from './Incubation/Incubation_facilities'
export {default as Startup} from './Incubation/Startup'
export {default as Focus_sector} from './Incubation/Focus_sector'
export {default as Onboarding_companies} from './Incubation/Onboarding_companies'
export {default as Incubation_Faculty_Mentors} from './Incubation/Incubation_Faculty_Mentors'
export {default as Incubation_laboratories} from './Incubation/Incubation_Laboratories'
export {default as Incubation_mou} from './Incubation/Incubation_mou'
export {default as Board_members} from './Incubation/Board_members'
export {default as EventGallery} from './Incubation/EventGallery'
export {default as ProtectedRoutes} from './ProtectedRoutes/ProtectedRoutes'
export {default as AdminOnly} from './ProtectedRoutes/AdminOnly'
export {default as StudentOnly} from './ProtectedRoutes/StudentOnly'
export {default as FeedbackAdminOnly} from './ProtectedRoutes/FeedbackAdminOnly'
export {default as Freshers_workshops} from './Freshers_asso/Freshers_workshops'
export {default as BulletinBoard} from './Admin_bulletin/BulletinBoard'
export {default as ClubsActivity} from './Clubs/ClubsActivity'
export {default as Itdept} from './Itdept/Itdept'
export {default as Placed_students} from './placement/Placed_students'
export {default as Result_coming} from './Result_coming/Result_coming'
export {default as Freshers_magazine} from './Freshers_asso/Freshers_magazine'
export {default as Mechasso} from './Mechdept/Mech_asso'
export{default as Pjc_fund} from './Pjc_fund/AlumniLogin'
export{default as AlumniLogin} from './Pjc_fund/AlumniLogin'
export{default as AlumniRegister} from './Pjc_fund/AlumniRegister'
export{default as AlumniRegisterVerify} from './Pjc_fund/AlumniRegisterVerify'
export{default as AlumniForgotPassword} from './Pjc_fund/AlumniForgotPassword'
export{default as AlumniPasswordOtp} from './Pjc_fund/AlumniPasswordOtp'
export{default as AlumniNewPassword} from './Pjc_fund/AlumniNewPassword'
export{default as AlumniProtectedRoutes} from './AlumniProtectedRoutes/AlumniProtectedRoutes'
export{default as AlumniContributionForm} from './Pjc_fund/AlumniContributionForm'
export{default as Pjc_dashboard} from './Pjc_fund/Pjc_dashboard'
export {default as ApprovedTransactions} from './Pjc_fund/ApproveTransactions'
export {default as RejectedTransactions} from './Pjc_fund/RejectedTransactions'
export {default as AdminDashboard} from './Pjc_fund/AdminDashboard'
export {default as PaymentEntry} from './Pjc_fund/PaymentEntry'
export {default as AlumniLanding} from './Pjc_fund/AlumniLanding'
export {default as AicteVaani} from './Aicte_Vaani/Aicte_vaani'
export {default as StudentVerification} from './StudentVerification/StudentVerification'

export { default as UGCPublicSelfDisclosure } from "./Ugc/UGCPublicSelfDisclosure";
export {default as It_faculties} from './Itdept/It_faculties';
export {default as Phonedirectory} from './PhoneDirectory/Phonedirectory';